import React from 'react'
import PrivacyIcon from  '../../Photos/PrivacityIcon.png'
import Icon1 from '../../Photos/Icon 50x50px- seguridad.png'
import Icon2 from '../../Photos/Icon 50x50px- internacional.png'
import Icon3 from '../../Photos/Icon 50x50px-IA INTELIGENCIA ARTIFICIAL.png'
import Icon4 from '../../Photos/Icon 50x50px-indicadores.png'
import backgroundImage  from '../../Photos/YMCBlockImage7.png'
import { useInView } from 'react-intersection-observer'
import { motion } from "framer-motion";


const itemVariants = {
  
        hidden: { opacity: 0, y: 40 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 1.2,
            ease: "easeOut",
          },
        },
      };
      
      const containerVariants = {
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.3,
          },
        },
      };

export default function Privacy() {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2,
      });
    
  return (
    <div style={{ backgroundImage: `url(${backgroundImage})`, backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>
      <div className='PrivacyFlex'>
        <div className='PrivacyGroup'>
            <img src={PrivacyIcon}/>
        </div>
        <div className='PrivacyGroup'>
            <div className='PrivacyTitle'> <span><b>  Privacidad total: </b></span> Cumplimos con los más altos estándares internacionales.</div>
      <div className='PrivacySubtitle'>Toda tu información está protegida con cifrado avanzado y almacenada de forma 100% privada. Cumplimos con HL7, GDPR y HIPAA. Tu información está segura, encriptada y fuera del alcance de terceros</div>
        </div>
      </div>
<motion.div className='PrivacityItemContainer'
 ref={ref}
 variants={containerVariants}
 initial="hidden"
 animate={inView ? "visible" : "hidden"}>
<motion.div  className='PrivacityItem' variants={itemVariants} >
    <div>
        <img src={Icon1}/>
    </div>
    <div className='PrivacityItemTitle'>
Tu clave, tu privacidad    </div>
</motion.div>
    <motion.div className='PrivacityItem' variants={itemVariants} >
    <div>
        <img src={Icon2}/>
    </div>
    <div  className='PrivacityItemTitle'>
        Cumplimiento de estandares internacionales
    </div>
</motion.div>
<motion.div className='PrivacityItem' variants={itemVariants} >
    <div>
        <img src={Icon3}/>
    </div>
    <div  className='PrivacityItemTitle'>
       IA de vanguardia
    </div>
</motion.div>
<motion.div className='PrivacityItem' variants={itemVariants} >
    <div>
        <img src={Icon4}/>
    </div>
    <div  className='PrivacityItemTitle'>
    Interoperabilidad
    </div>
</motion.div>
 </motion.div>
    </div>
  )
}
